import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-14b5984e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buy-more-wrap" }
const _hoisted_2 = { class: "step-item-content" }
const _hoisted_3 = { class: "service-price-wrap" }
const _hoisted_4 = { class: "current-price" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "￥", -1))
const _hoisted_6 = {
  key: 0,
  class: "origin-price"
}
const _hoisted_7 = { class: "unit" }
const _hoisted_8 = { class: "service-price-wrap" }
const _hoisted_9 = { class: "current-price" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "￥", -1))
const _hoisted_11 = {
  key: 0,
  class: "step-footer"
}
const _hoisted_12 = { class: "footer-right" }
const _hoisted_13 = {
  key: 1,
  class: "step-footer"
}
const _hoisted_14 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepList = _resolveComponent("StepList")!
  const _component_BuyMoreOptions = _resolveComponent("BuyMoreOptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ServiceEnum = _resolveComponent("ServiceEnum")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ConfirmOrder = _resolveComponent("ConfirmOrder")!
  const _component_PayNative = _resolveComponent("PayNative")!
  const _component_OfficePay = _resolveComponent("OfficePay")!
  const _component_OrderPrice = _resolveComponent("OrderPrice")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PayError = _resolveComponent("PayError")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_PayDetails = _resolveComponent("PayDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StepList, {
      class: "cm-ui-mb15",
      "active-index": _ctx.currentStepIndex,
      steps: _ctx.stepList
    }, null, 8, ["active-index", "steps"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_BuyMoreOptions, {
        "is-private": _ctx.isPrivate,
        "props-table-data": _ctx.serviceList,
        onChangeSelect: _ctx.changeRenewalServiceSelect
      }, null, 8, ["is-private", "props-table-data", "onChangeSelect"]), [
        [_vShow, _ctx.currentStepIndex === 0]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_ConfirmOrder, {
          ref: "confirmOrderNode",
          onConfirm: _ctx.handleConfirmOrder
        }, {
          table: _withCtx(() => [
            _createVNode(_component_el_table, {
              "max-height": 300,
              class: "table-wrap",
              ref: "tableNode",
              data: _ctx.serviceListSelected,
              width: "100%",
              height: "100%",
              "empty-text": _ctx.$t('common.noData')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('buyMore.colProductName'),
                  "min-width": "150"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.brandConfig.client_name), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('buyMore.colOrderType'),
                  "min-width": "200"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.$t('buyMore.orderTypeExpansionTerminal')), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('buyMore.colOrderContent'),
                  "min-width": "200"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_ServiceEnum, {
                      services: [scope.row.display_name]
                    }, null, 8, ["services"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('buyMore.colDiscountPrice'),
                  "min-width": "150"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(_toDisplayString(scope.row.unit_price / 100), 1)
                      ]),
                      (scope.row.unit_price !== scope.row.origin_unit_price)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "￥" + _toDisplayString(scope.row.origin_unit_price / 100), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('buyMore.unitPerTerminalPerYear')), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('buyMore.colPurchaseDuration'),
                  "min-width": "200"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.$t('buyMore.daysUntilDate', { days: scope.row.increase_days, date: _ctx.formatTimeStamp(scope.row.increase_time, 'YYYY-MM-DD') })), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('buyMore.colPurchaseTerminals'),
                  "min-width": "100"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.exceed_count) + _toDisplayString(_ctx.$t('buyMore.terminalUnitSuffix')), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "min-width": "100",
                  fixed: "right"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('buyMore.amount')) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      placement: "top",
                      effect: "light"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('buyMore.priceCalcTitle')), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('buyMore.priceCalcFormula')), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('buyMore.priceCalcNote366')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("i", null, [
                          _createVNode(_component_CmSvgIcon, {
                            name: "assets/icons/warn-border-gray",
                            size: 18,
                            monochrome: ""
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(_toDisplayString(scope.row.amount / 100), 1)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "empty-text"])
          ]),
          _: 1
        }, 8, ["onConfirm"])
      ], 512), [
        [_vShow, _ctx.currentStepIndex === 1]
      ]),
      (_ctx.currentStepIndex === 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.queryParams.pay_type === _ctx.PayType.online)
              ? (_openBlock(), _createBlock(_component_PayNative, {
                  key: 0,
                  visible: _ctx.queryParams.pay_type === _ctx.PayType.online,
                  "product-id": _ctx.payParams.product_id
                }, null, 8, ["visible", "product-id"]))
              : _createCommentVNode("", true),
            (_ctx.queryParams.pay_type === _ctx.PayType.office)
              ? (_openBlock(), _createBlock(_component_OfficePay, {
                  key: 1,
                  "product-id": _ctx.payParams.product_id,
                  onConfirm: _ctx.handleOfficePayConfirm
                }, null, 8, ["product-id", "onConfirm"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isPrivate)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.currentStepIndex === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createVNode(_component_OrderPrice, {
                    "price-data": _ctx.viewModel.priceData
                  }, null, 8, ["price-data"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_router_link, { to: "/dashboard/overview" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { theme: "orange" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.continueOverLimitUse')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    style: {"margin-left":"15px"},
                    disabled: !_ctx.serviceListSelected.length,
                    type: "primary",
                    theme: "orange",
                    onClick: _ctx.handleNextStep
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('buyMore.confirmPurchaseMore')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]))
            : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createVNode(_component_OrderPrice, {
                    "price-data": _ctx.viewModel.priceData
                  }, null, 8, ["price-data"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.currentStepIndex !== 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        theme: "orange",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentStepIndex--))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('buyMore.prevStep')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    style: {"margin-left":"15px"},
                    type: "primary",
                    theme: "orange",
                    onClick: _ctx.handleNextStep
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('buyMore.nextStep')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 512)), [
                [_vShow, _ctx.currentStepIndex !== 2]
              ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      "z-index": 9999,
      title: _ctx.$t('buyMore.dialogTip'),
      modelValue: _ctx.dialogErrorPayVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogErrorPayVisible) = $event)),
      width: 470,
      "close-on-click-modal": false,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PayError, {
          onPayCurrent: _ctx.payCurrent,
          onToHistory: _ctx.toHistory
        }, null, 8, ["onPayCurrent", "onToHistory"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_PayDetails, {
      modelValue: _ctx.dialogOrderVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogOrderVisible) = $event)),
      "product-id": _ctx.payParams.product_id,
      "order-status": "",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogOrderVisible = false))
    }, null, 8, ["modelValue", "product-id"])
  ]))
}